const literalMarkdown = new RegExp([
    /^---\r?\n[\s\S]*?\r?\n---(?=\r?\n|$)/.source, // Frontmatter.
    /^ {0,3}(?<fence>`{3,}|~{3,})[^\n]*\n[\s\S]*?(?:^ {0,3}\k<fence>[ \t]*(?=\r?$)|(?![\s\S]))/.source,
    /(?<ticks>`+)[\s\S]*?\k<ticks>(?!`)/.source,
    /<!--[\s\S]*?-->/.source,
    /^(?: {4}|\t)[^\r\n]*/.source, // Indented code.
    /(?:[A-Za-z]:\\|\\\\)[^\s<>`]*/.source,
    /\]\([^\s)]*\)/.source, // Link destinations.
].join("|"), "gm");

/** Recover over-escaped report layout without decoding arbitrary JSON/text escapes. */
export function normalizeSummaryMarkdown(markdown: string): string {
    if (!/\\(?:n|r)/.test(markdown)) return markdown;

    // Literal examples, metadata and Windows paths can legitimately contain \n.
    // Hide them while looking for Markdown structure in the surrounding prose.
    const literals: string[] = [];
    const protectedMarkdown = markdown.replace(literalMarkdown,
        literal => `\u0000${literals.push(literal) - 1}\u0000`,
    );
    const normalized = protectedMarkdown.replace(/[^\r\n]+/g, line => {
        const decoded = line.replace(/(?<!\\)\\(?:r\\n|n|r)/g, "\n");
        if (decoded === line) return line;
        // A heading or list on its own decoded line is evidence of broken layout.
        // Plain prose about the literal characters "\n" must remain untouched.
        const parts = decoded.split("\n");
        const structured = parts.some(part =>
            /^ {0,3}(?:#{1,6}[ \t]+\S|\*\*[^*]+\*\*[ \t]*$|__[^_]+__[ \t]*$)/.test(part))
            || parts.filter(part => /^ {0,3}(?:[-*+] |\d+\. )\S/.test(part)).length > 1;
        return structured ? decoded : line;
    });
    // Restore only our temporary literal placeholders.
    // eslint-disable-next-line no-control-regex
    return normalized.replace(/\u0000(\d+)\u0000/g, (_, index: string) => literals[Number(index)]);
}

